export const messages = {
  nb: {
    vis: "Vis",
    linjer: "linjer",
  },
};
